<template>
  <ion-button
    v-if="authenticated"
    fill="clear"
    class="header-messenger-btn"
    aria-label="Liga.Chat"
    @click="openMessenger"
  >
    <span class="ios-unread-icon-wrap">
      <ion-icon :icon="chatbubbleEllipsesOutline" slot="icon-only" />
      <span v-if="unreadLabel" class="ios-unread-badge ios-unread-badge--on-icon">{{ unreadLabel }}</span>
    </span>
  </ion-button>
  <span v-else class="header-messenger-spacer" aria-hidden="true" />
</template>

<script lang="ts">
import { IonButton, IonIcon } from '@ionic/vue';
import { chatbubbleEllipsesOutline } from 'ionicons/icons';
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  formatMessengerUnread,
  getMessengerUnreadTotal,
  refreshMessengerUnread,
  subscribeMessengerUnread,
} from '@/services/messenger-unread';
import store from '@/store';

export default defineComponent({
  name: 'HeaderMessengerButton',
  components: { IonButton, IonIcon },
  setup() {
    const router = useRouter();
    const unreadCount = ref(getMessengerUnreadTotal());
    let unsubscribeUnread: (() => void) | undefined;

    const authenticated = computed(() => !!store.getters.authenticated);
    const unreadLabel = computed(() => formatMessengerUnread(unreadCount.value));

    onMounted(() => {
      unsubscribeUnread = subscribeMessengerUnread(count => {
        unreadCount.value = count;
      });
      if (store.getters.authenticated) {
        void refreshMessengerUnread();
      }
    });

    onUnmounted(() => {
      unsubscribeUnread?.();
    });

    const openMessenger = () => {
      void router.push({ name: 'MessengerInbox' });
    };

    return {
      chatbubbleEllipsesOutline,
      authenticated,
      unreadLabel,
      openMessenger,
    };
  },
});
</script>

<style scoped>
/* Стили кружка даёт events-page-header / float-bar; здесь только размер иконки. */
.header-messenger-btn {
  margin: 0;
  width: 44px;
  min-width: 44px;
  height: 44px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  --color: var(--liga-chrome-text);
  overflow: visible;
}
.header-messenger-btn::part(native) {
  width: 44px;
  height: 44px;
  padding: 0;
  margin: 0;
  border-radius: 999px;
}
.header-messenger-btn ion-icon {
  font-size: 22px;
  color: var(--liga-chrome-text);
}
.header-messenger-spacer {
  display: inline-block;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}
</style>
